module.exports = __webpack_public_path__ + "img/icon_4_6.832094f3.png";